import clsx from 'clsx';
import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { getStoryblokAlt } from '../../helpers/common';

export default function Person({ blok }) {
  const styles = clsx('blok-person');

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div>
        <picture>
          <source
            type="image/avif"
            srcSet={blok.image.filename ? `${blok.image.filename}/m/208x208/filters:format(avif) 1x, ${blok.image.filename}/m/416x416/filters:format(avif) 2x` : undefined}
          />
          <img
            alt={getStoryblokAlt(blok.image)}
            className="h-52 w-52 rounded-full mb-4"
            src={blok.image.filename ? `${blok.image.filename}/m/416x416/filters:format(webp)` : undefined}
            width={208}
            height={208}
            loading="lazy"
          />
        </picture>
      </div>
      {blok.name}
      <br />
      {blok.role}
    </div>
  );
}
